import { Routes, Route } from 'react-router-dom';
import Homepage from './pages/Homepage';
import Staking from './pages/Staking';
import Dashboard from './pages/Dashboard';
import TradingAnalysis from './pages/TradingAnalysis';
import Documentation from './pages/Documentation';
import useHover from "./Hooks/useHover";
import Whitepaper from './pages/Whitepaper';
import ChainGuard from './components/ChainGuard';

function App() {
  // Activate hover sound for all buttons
  useHover("assets/sounds/hover.wav", 0.6);
  return (
    <>
      <ChainGuard />
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/staking' element={<Staking />} />
        <Route path='/analysis' element={<TradingAnalysis />} />
        <Route path='/documentation' element={<Documentation />} />
        <Route path='/whitepaper' element={<Whitepaper />} />
      </Routes>
    </>
  );
}

export default App;
